/**************************************************************************************************/
/*   File: /src/app/shared/models/geometric.export.input.ts                                       */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wednesday May 29th 2019                                                        */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { ExportType, SpatialDataTypeEnum } from '../enums';
import { Geometry } from './geometry';

/**
 * The geometric export input
 */
export class GeometricExportInput {
    /**
     * The export type 
     * @type {ExportType}
     */
    exportType: ExportType;
    /**
     * The spatial data type enum
     * @type {SpatialDataTypeEnum}
     */
    spatialDataType: SpatialDataTypeEnum;
    /**
     * The filter date as iso
     * @type {string}
     */
    filterDate?: string;
    /**
     * The language iso code
     * @type {string}
     */
    isoCode: string;
    /**
     * The plan code
     */
    planCode: string;
    /**
     * The ambiti code array
     * @type {string[]}
     */
    territorialAreasCodes: string[];
    /**
     * The flag to set if its selected full ambito
     * @type {boolean}
     */
    fullTerritorialAreas: boolean;
    /**
     * The geometry to extract object
     * @type {Geometry}
     */
    geometry: Geometry;

}